import React, { useEffect, useLayoutEffect } from 'react';
import { Container } from 'react-grid-system';
import { connect } from "react-redux";
import setCoverPresent, { setLightNav } from './redux/actions';
import './App.css';

const BG = '#e0e0e0';
const SESSION_KEY = 'experiments_unlocked';

function Experiments({ dispatch }) {
  const unlocked = sessionStorage.getItem(SESSION_KEY) === '1';

  useLayoutEffect(() => {
    const app = document.querySelector('.App');
    document.documentElement.style.backgroundColor = BG;
    document.body.style.backgroundColor = BG;
    if (app) app.style.backgroundColor = BG;
    return () => {
      document.documentElement.style.backgroundColor = '';
      document.body.style.backgroundColor = '';
      if (app) app.style.backgroundColor = '';
    };
  }, []);

  useEffect(() => {
    dispatch(setCoverPresent('no'));
    dispatch(setLightNav(BG));
    return () => dispatch(setLightNav(false));
  }, []);

  if (!unlocked) {
    return (
      <div className="wrapper" style={{ backgroundColor: BG, minHeight: '100vh', paddingBottom: 1 }} />
    );
  }

  return (
    <div className="wrapper" style={{ backgroundColor: BG, minHeight: '100vh', paddingBottom: 1 }}>
      <div className="inner-wrapper">
        <Container fluid className="page-pad">
          <div className="selected-work-label" style={{ color: '#000' }}>Experiments</div>
        </Container>
      </div>
    </div>
  );
}

export default connect()(Experiments);
